import { useAtom } from "jotai";
import { toast } from "sonner";
import { formsSubmitAtom } from "../atom/atom";

export default function useHandleErrors() {
    const [, setIsSubmitting] = useAtom(formsSubmitAtom);

    const handleErrors = (response: any) => {
        if (!response.success) {
            if (response.data?.errors) {
                response.data.errors?.forEach((error: any) => {
                    const message =
                        typeof error === "string"
                            ? error
                            : error?.message ?? String(error ?? "");
                    if (!message) {
                        return;
                    }
                    if (typeof error === "object" && error?.warning) {
                        toast.warning(message);
                    } else {
                        toast.error(message);
                    }
                });
            } else {
                if(response.warning) {
                    const warningMessage = JSON.parse(response.message);
                    
                    warningMessage?.forEach((warning: string) => {
                        toast.warning(warning);
                    });
                } else {
                    toast.error(response.message);
                }
            }

            
        } else {
            toast.success(response.message);
        }
        setIsSubmitting(false);
    }

    return { handleErrors };
}